var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMccPetrol(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8390",
    "data-name": "Rectangle 8390",
    width: 28,
    height: 28,
    transform: "translate(390 2096)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8389",
    "data-name": "Rectangle 8389",
    width: 19.955,
    height: 23.811,
    transform: "translate(5.022 2.095)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Petrol",
    transform: "translate(-390 -2096)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35243",
    "data-name": "Group 35243",
    transform: "translate(388.978 2095.905)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35242",
    "data-name": "Group 35242",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35888",
    "data-name": "Path 35888",
    d: "M24.188,5.629l-3.26-3.26a.954.954,0,0,0-1.349,1.349l1.349,1.349v2.7a2.628,2.628,0,0,0,2.024,2.577v6.532a1.013,1.013,0,0,1-2.025,0v-1.35A3.7,3.7,0,0,0,18.312,12V4.888A2.758,2.758,0,0,0,15.555,2.13H8.667a2.758,2.758,0,0,0-2.76,2.756V21.311h12.4V14.232a1.737,1.737,0,0,1,.592,1.293v1.349a3.036,3.036,0,0,0,6.072,0V7.535a2.692,2.692,0,0,0-.789-1.907m-8.626,5.058H8.667V5.171h6.889Z",
    fill: "#b2b4c2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8388",
    "data-name": "Rectangle 8388",
    width: 14.178,
    height: 2.696,
    transform: "translate(5.022 23.21)",
    fill: "#b2b4c2"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMccPetrol);
export default __webpack_public_path__ + "static/media/mcc_petrol.b35f4ef64f0dd7d4063401b9726c688d.svg";
export { ForwardRef as ReactComponent };